import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { Header } from '@expo/html-elements';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsHeaderLarge = (props: Props) => {
  const { children } = props;

  return <Header style={styles.container}>{children}</Header>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
